<template>
<div>
  <div class="content-wrapper">
    <margin-title title="" subtitle="Referrals" />
    <referral-nav />
    <referrals-list :referrals="referrals" @select="onRoleSelected" />
  </div>
</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import MarginTitle from '@/components/margin-title'
import ReferralNav from '@/components/referrals/roles-nav'
import ReferralsList from '../../components/referrals/roles-list'

export default {
  components: { MarginTitle, ReferralNav, ReferralsList },
  computed: {
    ...mapState('users', ['user']),
    ...mapState('referrals', [
      'referrals'
    ])
  },
  methods: {
    ...mapMutations('referrals', [
      'setCurrentJobReferrals'
    ]),
    ...mapActions('referrals', [
      'getReferrals'
    ]),
    onRoleSelected (item) {
      // this.setCurrentJobReferrals(item.referrals)
      this.$router.push(`/referrals/job/${item.id}`)
    }
  },
  mounted () {
    this.getReferrals()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/referrals/referrals.vue